module.exports = __webpack_public_path__ + "img/2.43f37063.jpg";